import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import "./InstructionSendFeedback.css";
import "./PromoInstructionSendInfo.css";
import axios from "axios";
import { Markup } from "interweave";
import noImage from '../../../../../../assets/images/settings/no-image.png';
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";


const ViewPromoList = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const id = props.match.params.id;
  const [audition, setAudition] = React.useState({});
  const [runningInstructionInfo, setRunningInstructionInfo] = React.useState({});

  const getSingleAuditionInstructionInfo = (id) => {
    axios.get(`/api/audition-admin/audition/promo-instruction/${id}`).then((res) => {
      if (res.data.status === 200) {
        setAudition(res.data.event);
        setRunningInstructionInfo(res.data?.promo_instruction);
     
      }
    });
  };

  useEffect(() => {
    getSingleAuditionInstructionInfo(id);
  }, [id]);

  return (
    <div className="my-2">
      <div className="accordion" id="accordionExample">
        <div
          className="accordion-item mb-1"
          style={{ border: "none", outline: "none" }}
        >
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button accordionHeader text-light"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              style={{ boxShadow: "none" }}
            >
              Start status
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body bg-dark">
              {/* <Status /> */}
              <div>
          
                <div className="container my-3">
                  <div
                    style={{ border: "2px solid gold", borderRadius: "10px" }}
                  >
                    <div className="p-4">
                      <h5 className="text-warning">Title</h5>
                      <div className="card star-cardColor2">
                        <div className="card-body ">
                          <p className="text-light">
                            {audition &&
                              audition.title}
                          </p>
                        </div>
                      </div>

                      <div className="mt-4">
                        <h5 className="text-warning">Instructions</h5>
                        <div>
                          {runningInstructionInfo && (
                            <p className="text-light my-2">
                              <Markup content={runningInstructionInfo?.instruction} />
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="container topBannerVideoRound" >
                        <img
                          style={{ height: '350px' }}
                          src={
                            runningInstructionInfo?.image
                              ?imageCdnUrl+runningInstructionInfo?.image
                              : noImage
                          }
                          alt=""
                          className="img-fluid w-100"
                        />
                      </div>

                      <div className="container topBannerVideoRound my-4">
                        <ReactPlayer
                          url={
                            runningInstructionInfo?.video
                              ? videoCdnUrl+runningInstructionInfo?.video
                              : "https://youtu.be/dgfTiONcnTc"
                          }
                          playing={false}
                          volume={1}
                          width="100%"
                          controls={true}
                          autoplay
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPromoList;

